// components/ProductInfo.jsx - Product Information Component
import { LucideHandCoins, ScaleIcon, ScanBarcodeIcon } from 'lucide-react';
import React from 'react';
import NumberFormat from 'react-number-format';

const ProductInfo = ({ product, index, user, discounted, product_price_without, translate }) => {
  return (
    <div className='product-info'>
      {/* شماره ردیف */}

      {/* نام محصول */}
      <div className='product-title-section'>
        <h3 className='product-title'>{product['products']['accounting_name_product']}</h3>
      </div>

      {user?.id ? (
        <div className='product-barcode-section'>
          <ScanBarcodeIcon className='info-icon' size={18} />
          <span className='product-barcode'>{product['products']['accounting_barcode'] || 'برای مشاهده وارد شوید'}</span>
        </div>
      ) : null}

      {/* وزن محصول */}
      {product['products']['accounting_weight'] && (
        <div className='product-weight-section'>
          <ScaleIcon className='info-icon' size={18} />

          <span className='product-weight'>{product['products']['accounting_weight']} گرم</span>
        </div>
      )}

      {/* قیمت و تخفیف */}
      <div className='product-pricing'>
        {discounted && (
          <div className='discount-tag-container'>
            <span className='discount-tag'>{product['discount']['percent']}% تخفیف</span>
          </div>
        )}
        <div className='price-container'>
          <span className='current-price'>
            <LucideHandCoins className='info-icon' size={18} />
            <NumberFormat value={product['final_price'] / 10} displayType={'text'} thousandSeparator={true} suffix=' تومان' />
          </span>
          {discounted && (
            <span className='original-price'>
              <NumberFormat value={(product_price_without - product['final_price']) / 10} displayType={'text'} thousandSeparator={true} suffix=' تومان' />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
